export interface EmployeeLocation {
  id: number;
  name: string;
  region: number;
  displayOrder: number;
  inactive: boolean;
}

export const EmployeeLocationNotApplicable = 1;
